import { PeopleOneOutlineIcon } from '@repo/ui/icons'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { getCenterTeam } from '../../../../../api/centers/get-center-team'
import useAffectedStaff from '../../../../../lib/hooks/use-affected-staff'
import useTranslate from '../../../../../lib/hooks/use-translate'
import { staffQualificationEnumMapping } from '../../../../../lib/types/enums/staff/staff-qualifications.enum'
import { CenterTeamMember } from '../../../../../lib/types/models/center/center-team'
import ContactCard, { ContactInfo } from '../../../../elements/contact-card'
import IconBox from '../../../../elements/icon-box'

const StaffPersonalSpaceMyTeamSection = () => {
  const { affectedStaff } = useAffectedStaff()
  const { t } = useTranslate()

  const centerIds = affectedStaff?.staffRequest.centers?.map((c) => c.id)

  const { data: centerTeams } = useQuery({
    queryKey: ['center-teams', centerIds],
    queryFn: () => {
      if (centerIds) return Promise.all(centerIds.map((id) => getCenterTeam(id)))
    },
    enabled: !!centerIds && centerIds.length > 0
  })

  const contactInfos = useMemo(() => {
    const members: CenterTeamMember[] = (centerTeams ?? []).flat()
    const seen = new Set<string>()

    return members
      .filter((member) => {
        const key = `${member.type}-${member.affectedStaffId ?? member.email}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })
      .map(
        (member): ContactInfo => ({
          firstName: member.firstName,
          lastName: member.lastName,
          email: member.email,
          phoneNumber: member.phoneNumber,
          profilePicture: member.picturePath ?? undefined,
          position: member.qualification
            ? t(staffQualificationEnumMapping[member.qualification].label)
            : undefined
        })
      )
  }, [centerTeams, t])

  // the backend returns no member while the staff must not see the team (incomplete, or after the contract)
  if (contactInfos.length === 0) return null

  return (
    <IconBox
      mode="inner-box"
      className="gap-3"
      icon={PeopleOneOutlineIcon}
      title={t('staff.personal.space.my.journeys.details.tab.home.my.team')}
    >
      <div className="grid grid-cols-3 gap-3 mobile:grid-cols-1">
        {contactInfos.map((contactInfo, index) => (
          <ContactCard
            key={`${contactInfo.firstName}-${contactInfo.lastName}-${index}`}
            {...contactInfo}
          />
        ))}
      </div>
    </IconBox>
  )
}

export default StaffPersonalSpaceMyTeamSection
